// @flow
import * as React from "react";
import { connect } from "react-redux";
import moment from "moment";

import { inferLocale } from "./common/Gettext";
import { mapDispatchToFetch } from "./common/fetch";

import type { State as ReduxState } from "../redux/reducer";
import type { Profile } from "../redux/CommonTypes";
import type { Dispatch } from "../redux/action";

type Props = {
  profile: Profile,
  fetch: (method: string, options?: Object) => Promise<Object>,
  dispatch: Dispatch
};

type State = {
  changeLocaleFetching: boolean
};

function withLanguage(WrappedComponent: $FlowFixMe) {
  class Lang extends React.Component<Props, State> {
    state = {
      changeLocaleFetching: false
    };

    handleLocaleChange = (nextLocale: string) => {
      if (typeof nextLocale !== "string") {
        return;
      }

      if (this.props.profile != null) {
        const prevLocale = this.props.profile.locale;

        this.setState({ changeLocaleFetching: true });

        return this.props
          .fetch(`/api/change-locale?locale=${nextLocale}`, {
            unstable_dontInferResponse: true
          })
          .then(res => (res.status === "OK" ? nextLocale : prevLocale))
          .catch(() => prevLocale)
          .then(locale => {
            const momentLocale = {
              en: "en",
              jp: "jv",
              ph: "tl-ph",
              ru: "ru",
              th: "th",
              hi: "hi",
              vn: "vi",
              ar: "ar"
            };

            moment.locale(momentLocale[locale] || "en");

            this.setState({ changeLocaleFetching: false });
            this.props.dispatch({
              type: "UPDATE_LOCALE",
              payload: locale
            });
          })
          .then(() => this.props.fetch("/api/profile"))
          .then(profile => {
            this.props.dispatch({
              type: "RECEIVE_PROFILE",
              payload: profile
            });
          });
      } else {
        this.props.dispatch({
          type: "UPDATE_LOCALE",
          payload: nextLocale
        });
      }
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          showLoader={this.state.changeLocaleFetching}
          onLocaleChange={this.handleLocaleChange}
        />
      );
    }
  }

  return connect(mapStateToProps, mapDispatchToFetch)(Lang);
}

function mapStateToProps(state: ReduxState) {
  return {
    locale: inferLocale(state),
    locales: state.apiConfigs && state.apiConfigs.locales,
    profile: state.profile
  };
}

export default withLanguage;



// WEBPACK FOOTER //
// ./src/components/withLocaleChange.js